import { Content as _Content, Columns } from '#~/common/editor/index.js';
import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { Preview } from '../preview.jsx';
import { Selector } from './selector.jsx';

/** Source `<Content>` component. */
export const Content = (props: HtmlAttributes): ReactElement => {
  return (
    <_Content {...props}>
      <Columns>
        {/* Select an audio source */}
        <div>
          <h3>Select an audio source</h3>
          <Selector />
        </div>

        {/* Audio preview */}
        <div>
          <h3>Preview</h3>
          <Preview />
        </div>
      </Columns>
    </_Content>
  );
};
